module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "headerTop"
    }
  }, [(_vm.slides.length == 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.banner),
      expression: "banner"
    }],
    attrs: {
      "src": _vm.banner,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.slides.length > 0) ? _c('div', [_c('swiper', {
    attrs: {
      "slides": _vm.slides
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dbe60ecc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tplCommon/header_pic/header_pic.vue
// module id = 826
// module chunks = 10